module.exports = {
  text: `Каждые 289 лет вся Мультивселенная сходит с ума. Как по расписанию.`,
  author: `Квинт Стормбеллоу, скальный гном, искатель приключений`,
}
